import React from "react";
import { ScrollView, useWindowDimensions, View } from "react-native";
import commonStyle from "../../assets/styles/common-style";
import DropDownView from "./DropDownView";
import { Platform } from "react-native";
import { Header } from "../header/Header";
import { createPlatformStyles, theme } from "../../theme/theme";
import { isTablet } from "react-native-device-info";
import { messages } from "../../resources/strings";
import { getBackgroundColor } from "@lib/utilities/HelperFunctions";
import { useAppSelector } from "@lib";
import { isOpaqueStripeDisabled } from "@lib/utilities/Constants";

const PageWrapper = ({
  children,
  navigation,

  arrayPolicyList,
  screenName,
  errorData = { message: "", screenName: "" },
}: any) => {
  const { isLoading } = useAppSelector((state) => state.policyReducer);
  const { loading } = useAppSelector((state) => state.policyDetailReducer);
  const { height, width } = useWindowDimensions();

  return (
    <View
      style={[
        styles.mainContainer,
        { backgroundColor: getBackgroundColor(screenName) },
      ]}
      dataSet={{ media: ids?.mainContainer }}
    >
      {!isOpaqueStripeDisabled && (
        <View
          style={[
            styles.bgEffect,
            { backgroundColor: getBackgroundColor(screenName, true) },
          ]}
          dataSet={{ media: ids.bgEffect }}
        />
      )}

      <View
        style={styles.headerContainer}
        dataSet={{ media: ids.headerContainer }}
      >
        <Header screenName={screenName} navigation={navigation} />
      </View>

      <ScrollView
        bounces={false}
        showsVerticalScrollIndicator={false}
        style={[
          styles.scrollArea,
          {
            height: height,
            zIndex: errorData.message === messages.error.noDataFound ? 999 : 90,
          },
        ]}
        dataSet={{ media: ids?.scrollArea }}
      >
        <View
          style={[
            styles.container,
            {
              ...Platform.select({
                web: {},
                android: {
                  marginTop: isTablet()
                    ? height > width
                      ? height * 0.08
                      : width * 0.08
                    : "22%",
                },
                ios: {
                  marginTop: isTablet()
                    ? height > width
                      ? height * 0.1
                      : width * 0.1
                    : height * 0.14,
                },
              }),
            },
          ]}
          dataSet={{ media: ids?.container }}
        >
          {!(isLoading || loading) && (
            <>
              <View
                style={[styles.choosePolicyText]}
                dataSet={{ media: ids.choosePolicyText }}
              ></View>
              {(arrayPolicyList.length && (
                <DropDownView arrayPolicyList={arrayPolicyList ?? []} />
              )) ||
                null}
              {children}
            </>
          )}
        </View>
      </ScrollView>
      {!isOpaqueStripeDisabled && (
        <View
          style={[commonStyle.styles.bgEffectBottom]}
          dataSet={{ media: commonStyle.ids.bgEffectBottom }}
        />
      )}
    </View>
  );
};

export default PageWrapper;

export const { ids, styles } = createPlatformStyles({
  mobile: {
    bgEffectBottom: {
      backgroundColor: theme.colors.primary,
      position: "absolute",
      bottom: -227,
      right: -101,
      transform: [{ rotate: "45deg" }],
      width: 400,
      height: 800,
      "@media (min-width: 200px)": {
        display: "none",
      },
      "@media (min-width: 700px)": {
        bottom: -472,
        right: -101,
        display: "flex",
      },
      "@media (min-width: 1150px)": {
        bottom: -472,
        right: -101,
      },
      "@media (min-width: 1281px)": {
        bottom: -472,
        right: -101,
      },
      "@media (min-width: 1441px)": {
        bottom: -472,
        right: -101,
      },
      "@media (min-width: 1681px)": {
        bottom: -472,
        right: -101,
      },
    },
    bgEffect: {
      backgroundColor: theme.colors.primary,
      position: "absolute",
      "@media (min-width: 700px)": {
        top: -272,
        left: -101,
      },
      top: -527,
      left: -101,
      transform: [{ rotate: "45deg" }],
      width: 400,
      height: 800,
    },
    mainContainer: {
      backgroundColor: theme.colors.secondary,
      overflow: "hidden",

      flex: 1,
      height: "100%",
      width: "100%",
    },
    choosePolicyText: {
      fontFamily: theme.fontFamily.robotoSlabBold,
      maxWidth: 600,
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
      alignItems: "center",
      ...Platform.select({
        ios: {
          "@media (min-width: 200px)": {
            paddingLeft: theme.spacing.md,
            display: "flex",
          },
          "@media (min-width: 385px)": {
            paddingLeft: theme.spacing.md,
          },
          "@media (min-width: 700px)": {
            paddingLeft: 0,
            display: "none",
          },
        },
        android: {
          "@media (min-width: 200px)": {
            paddingLeft: theme.spacing.md,
            display: "flex",
          },
          "@media (min-width: 385px)": {
            paddingLeft: theme.spacing.md,
          },
          "@media (min-width: 700px)": {
            paddingLeft: 0,
            display: "none",
          },
        },
      }),
    },
    scrollArea: {
      display: "flex",
      flex: 1,
      "@media (min-width: 700px)": {
        paddingHorizontal: theme.spacing.xxl4,
      },
    },
    container: {
      marginTop: theme.margin.cs,
      marginLeft: theme.margin.lg,
      marginRight: theme.margin.md,

      "@media (min-width: 700px)": {},
      "@media (min-width: 1000px)": {
        maxWidth: 1180,
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
      },
      backgroundColor: "transparent",
      elevation: 16,
    },
    headerContainer: { zIndex: theme.zIndex.mid },
    heading: {
      color: theme.colors.white,
      fontWeight: theme.fontweight.bold as any,
      marginTop: theme.spacing.none,
      ...Platform.select({
        ios: {
          display: "flex",
          "@media (min-width: 200px)": {
            fontSize: theme.fontsize.cs,
          },
          "@media (min-width: 385px)": {
            fontSize: theme.fontsize.md,
          },
          "@media (min-width: 700px)": {
            fontSize: theme.fontsize.mmd,
          },
        },
        android: {
          display: "flex",
        },
      }),
    },
  },
  web: {
    bgEffectBottom: {
      backgroundColor: theme.colors.primary,
      position: "absolute",
      bottom: -227,
      right: -101,
      transform: [{ rotate: "45deg" }],
      width: 400,
      height: 800,
      "@media (min-width: 200px)": {
        display: "none",
      },
      "@media (min-width: 700px)": {
        bottom: -472,
        right: -101,
        display: "block",
      },
      "@media (min-width: 1150px)": {
        bottom: -472,
        right: -101,
      },
      "@media (min-width: 1281px)": {
        bottom: -472,
        right: -101,
      },
      "@media (min-width: 1441px)": {
        bottom: -472,
        right: -101,
      },
      "@media (min-width: 1681px)": {
        bottom: -472,
        right: -101,
      },
    },
    bgEffect: {
      backgroundColor: theme.colors.primary,
      position: "absolute",
      "@media (min-width: 700px)": {
        top: -272,
        left: -101,
      },
      top: -527,
      left: -101,
      transform: [{ rotate: "45deg" }],
      width: 400,
      height: 800,
    },
    mainContainer: {
      backgroundColor: theme.colors.secondary,
      overflow: "hidden",

      flex: 1,
      height: "100%",
      width: "100%",
    },
    choosePolicyText: {
      maxWidth: 600,
      width: "100%",
      fontFamily: theme.fontFamily.robotoSlabBold,
      fontWeight: theme.fontweight.bold,
      marginLeft: "auto",
      marginRight: "auto",
      alignItems: "center",
      display: "flex",
    },
    heading: {
      color: theme.colors.white,
      fontWeight: theme.fontweight.bold as any,
      marginTop: theme.spacing.none,
      display: "none",
    },
    scrollArea: {
      bottom: theme.spacing.none,
      left: theme.spacing.none,
      right: theme.spacing.none,
      height: "100%",
    },
    container: {
      height: theme.height * 0.8,
      marginTop: theme.margin.cs,
      marginLeft: theme.margin.lg,
      marginRight: theme.margin.md,
      "@media (min-width: 700px)": {},
      "@media (min-width: 1000px)": {
        maxWidth: 1180,
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
      },
      backgroundColor: "transparent",
      elevation: 16,
    },
  },
});
